import React from 'react';

const Snackbar = ({ message, isOpen, type = 'success' }) => {
  if (!isOpen) return null;

  const getBackgroundColor = () => {
    switch (type) {
      case 'error': return '#dc3545';
      case 'warning': return '#ffc107';
      default: return '#28a745';
    }
  };

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      backgroundColor: getBackgroundColor(),
      color: 'white',
      padding: '16px 24px',
      borderRadius: '8px',
      boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
      zIndex: 1000,
      animation: 'slideUp 0.3s ease-out'
    }}>
      {message}
    </div>
  );
};

export default Snackbar; 